export default __webpack_public_path__ + "static/media/alarm.173adcd6.svg";